// extracted by mini-css-extract-plugin
export default {"header":"firewall-history_header__LIHh5","details_container":"firewall-history_details_container__QBE88"};